import { alpha, useTheme } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
// import Grid from '@mui/material/Unstable_Grid2';
import { HEADER } from 'src/layouts/config-layout';
import Iconify from 'src/components/iconify';
import Image from 'src/components/image';
import Stack from '@mui/material/Stack';
import { Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import { bgGradient } from 'src/theme/css';
import dashboardImage from 'src/assets/funnelLoop/dashboard.png';
import ecommerce from 'src/assets/funnelLoop/e-commerce-icon-.png';
import game from 'src/assets/funnelLoop/game.png';
import saas from 'src/assets/funnelLoop/saas_icon.png';
import styled from '@emotion/styled';
import { useBoundingClientRect } from 'src/hooks/use-bounding-client-rect';
import { useRef } from 'react';
import { useResponsive } from 'src/hooks/use-responsive';
import { Grid } from '@mui/material';

// ----------------------------------------------------------------------

const ImageContainer = styled.div`
  position: absolute;
  max-width: 72%;
  bottom: 5%;
  width: 72%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  z-index: 0;
  right: 0;
  height: 100%;

  @media (max-width: 1700px) {
  }
`;

const redColor = 'rgb(255, 76, 81)';
const yellowColor = 'rgb(224, 158, 0)';
const greenColor = 'rgb(76, 178, 0)';

export default function HomeHero() {
  const theme = useTheme();

  const containerRef = useRef<HTMLDivElement>(null);

  const mdUp = useResponsive('up', 'md');

  const mdDown = useResponsive('down', 'md');

  const container = useBoundingClientRect(containerRef);

  const offsetLeft = container?.left;

  return (
    <Box
      sx={{
        ...bgGradient({
          color: alpha(theme.palette.background.default, 0.9),
          imgUrl: '/assets/background/overlay_1.jpg',
        }),
        overflow: 'hidden',
        position: 'relative',
        height: { md: `calc(100vh - ${HEADER.H_DESKTOP}px)` },
      }}
    >
      <Container sx={{ height: 1 }}>
        <Grid container columnSpacing={3} alignItems="center" sx={{ height: 1 }}>
          <Grid
            xs={12}
            sx={{
              zIndex: '10',
            }}
          >
            <Stack
              spacing={5}
              justifyContent="center"
              alignItems={{ xs: 'center', md: 'flex-start' }}
              sx={{
                py: 15,
                textAlign: { xs: 'center', md: 'left', '@media (min-width:600px)': '1.9rem' },
              }}
            >
              <Typography variant="h1">
                <Box component="span" sx={{ color: redColor }}>
                  Stop&nbsp;
                </Box>
                Inefficient Marketing. <br />{' '}
                <Box component="span" sx={{ color: yellowColor }}>
                  Save{' '}
                </Box>{' '}
                More. <br />
                <Box component="span" sx={{ color: greenColor }}>
                  {` Earn `}
                </Box>
                More.
              </Typography>

              <Typography sx={{ color: 'text.secondary' }}>
                The first AI-Based What-If platform for <br /> your marketing budget.
              </Typography>
              <Typography sx={{ color: 'text.secondary' }}>Start saving money today!</Typography>
              <Button
                style={{
                  backgroundColor: 'rgba(22, 177, 255, 0.85)',
                }}
                color="inherit"
                size="large"
                variant="contained"
                endIcon={<Iconify icon="carbon:launch" />}
                target="_blank"
                rel="noopener"
                href="https://app.funneloop.ai/register/"
              >
                {"Get Started - It's Free!"}
              </Button>

              <Stack spacing={3}>
                <Typography variant="overline">AVAILABLE FOR</Typography>
                <Stack direction="row" spacing={2.5}>
                  <Tooltip title="Saas" placement="top" arrow>
                    <img src={saas} alt="" style={{ width: '36px' }} />
                  </Tooltip>
                  <Tooltip title="E-commerce" placement="top" arrow>
                    <img src={ecommerce} alt="" style={{ width: '36px' }} />
                  </Tooltip>
                  <Tooltip title="Gaming" placement="top" arrow>
                    <img src={game} alt="" style={{ width: '36px' }} />
                  </Tooltip>
                </Stack>
              </Stack>
            </Stack>
          </Grid>

          <Grid xs={12} md={7}>
            <Box ref={containerRef} />
          </Grid>
        </Grid>
      </Container>

      {mdUp && (
        <ImageContainer>
          <Image
            width="90%"
            top="35%"
            visibleByDefault
            disabledEffect
            alt="home hero"
            src={dashboardImage}
          />
        </ImageContainer>
      )}
      {/* {mdUp && (
             <Box
              sx={{
                maxWidth: 1280,
                position: 'absolute',
                bottom: { md: '30%', lg: 190 },
                right: { md: -110, xl: 0 },
                width: { md: `calc(100% - ${offsetLeft}px)` },
              }}
            >
              <Image
                visibleByDefault
                disabledEffect
                alt="marketing market"
                src="/assets/illustrations/illustration_marketing_market.svg"
              />
            </Box>
          )} */}
    </Box>
  );
}
